import { ILocation, ILocationPost, ILocationPatientId } from '../interfaces/ILocation';
import Api from './Api';

const BASE_PATH = '/v3/locations';

export const Locations = {
  async getAllLocations(): Promise<ILocation[]> {
    const { locations } = await Api.get(`${BASE_PATH}`);
    return locations;
  },
  async getLocationsByPatientId(
    patientId: number | undefined,
    serviceVisitId: number | undefined
  ): Promise<ILocationPatientId> {
    const params: { [key: string]: number } = {};
    if (patientId !== undefined) {
      params.patientId = patientId;
    }
    if (serviceVisitId !== undefined) {
      params.serviceVisitId = serviceVisitId;
    }

    const { results, error } = await Api.get(`${BASE_PATH}`, params);
    if (error) {
      throw error;
    }
    return results;
  },
  async createLocation(data: ILocationPost): Promise<ILocationPost> {
    const { results, error } = await Api.post(`${BASE_PATH}`, data);
    if (error) {
      throw error;
    }
    return results;
  },
  async getLocationInfo(id: number): Promise<ILocation> {
    const { location, error } = await Api.get(`${BASE_PATH}/${id}`);
    if (error) {
      throw error;
    }
    return location;
  },
  async populateLocations(): Promise<any> {
    const { newRecords, errors } = await Api.post(`${BASE_PATH}/populate`, {});
    return { newRecords, errors };
  },
  async editLocation(data: ILocationPost): Promise<ILocationPost> {
    const { id } = data;
    const { results, error } = await Api.put(`${BASE_PATH}/${id}`, data);
    if (error) {
      throw error;
    }
    return results;
  },
};
